import {Column} from 'react-table'
import {createColumnHelper} from '@tanstack/react-table'
import {formatNumber} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {CardsWidget7} from '../../../../_metronic/partials/widgets'
import {transformedRecord} from './api'
import {KTIcon} from '../../../../_metronic/helpers'
const columnHelper = createColumnHelper<transformedRecord>()

export const applyHeaderStyles = () => {
  const styleId = 'register-sheet-header-styles'

  if (!document.getElementById(styleId)) {
    const style = document.createElement('style')
    style.id = styleId
    style.innerHTML = `
      .amount-header-container {
        position: relative;
        text-align: center;
      }
    `
    document.head.appendChild(style)
  }
}
export const getReceivableAndPayableSheetColumns = (
  from: string,
  to: string,
  totalCredit: number,
  totalDebit: number
) => [
  // Column for Group (Parent Group and Sub Group)
  columnHelper.accessor('ledgerId', {
    header: () => <span className='px-3'>#</span>,
    cell: ({row, getValue}) => {
      if (row.depth === 0) {
        // console.log(row)
        // Parent Group row
        return (
          <div className='d-flex align-items-center max-w-125px px-3 justify-content-center'>
            {row.index + 1}
          </div>
        )
      }
    },
    footer: () => <div className='px-3 text-center'>Total</div>,
  }),
  columnHelper.accessor('ledgerCode', {
    id: 'ledger_code',
    header: () => <div className='amount-header-container px-3'>Ledger Code</div>,
    cell: ({row, getValue}) => {
      let className = ''

      if (row.depth === 0) {
        className = 'text-dark fw-bold text-center text-hover-primary'
      } else {
        className = 'text-muted text-center text-hover-primary'
      }
      return (
        <div className='d-flex justify-content-center'>
          <Link
            to={`/transactions/trial-balance/ledger?ledgerId=${
              row.original.ledgerId || ''
            }&from=${from}&to=${to}`}
            className={className}
          >
            {getValue()?.toLocaleString() || '-'}
          </Link>
        </div>
      )
    },
    footer: () => null,
  }),
  // Column for Ledger (Parent Ledger and Sub Ledger)
  columnHelper.accessor('ledger', {
    header: () => <span className='px-3'>Ledger</span>,
    cell: ({row, getValue}) => {
      // For Ledger row (depth 2)
      if (row.depth === 0) {
        const ledger = getValue()
        // console.log(ledger)
        return (
          <div className='d-flex align-items-center justify-content-center px-3'>
            {row.getCanExpand() && row.original.subLedger && row.original.subLedger.length > 0 && (
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '10px',
                  cursor: 'pointer',
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  row.toggleExpanded()
                }}
              >
                {row.getIsExpanded() ? <KTIcon iconName='up' /> : <KTIcon iconName='down' />}
              </span>
            )}
            <Link
              to={`/transactions/trial-balance/ledger?ledgerId=${
                row.original.ledgerId || ''
              }&from=${from}&to=${to}`}
              className='text-dark fw-bold text-hover-primary'
            >
              {ledger}
            </Link>
          </div>
        )
      }
      // For Sub Ledger row (depth 3)
      else {
        const subLedger = row.original.ledger
        // console.log(row.original)
        return (
          <div className='px-3 d-flex justify-content-center'>
            <Link
              to={`/transactions/trial-balance/ledger?ledgerId=${
                row.original.ledgerId || ''
              }&from=${from}&to=${to}`}
              className='text-center text-hover-primary'
            >
              {subLedger || '-'}
            </Link>
          </div>
        )
      }
    },
    footer: () => null,
  }),
  // Column for Amount
  columnHelper.accessor('debit', {
    id: 'ledger_debit',
    header: () => <div className='amount-header-container px-3'>Debit</div>,
    cell: ({row, getValue}) => {
      let className = ''

      if (row.depth === 0) {
        className = 'text-end px-3'
      } else {
        className = 'text-end px-3'
      }
      return (
        <div className={className}>{getValue() ? formatNumber(getValue()!.toString()) : '-'}</div>
      )
    },
    footer: ({table}) => {
      return <div className='text-end px-3'>{formatNumber(totalDebit)}</div>
    },
  }),
  columnHelper.accessor('credit', {
    id: 'ledger_credit',
    header: () => <div className='amount-header-container px-3'>Credit</div>,
    cell: ({row, getValue}) => {
      let className = ''

      if (row.depth === 0) {
        className = 'text-end px-3'
      } else {
        className = 'text-end px-3'
      }
      return (
        <div className={className}>{getValue() ? formatNumber(getValue()!.toString()) : '-'}</div>
      )
    },
    footer: ({table}) => {
      return <div className='text-end px-3'>{formatNumber(totalCredit)}</div>
    },
  }),
]
